import React from 'react';
import { Link } from 'react-router-dom';
import Linkedin from "../assets/LinkedinPic.jpeg";
import "../styles/Developers.css";

export const Lorenzo = () => {
    return(
        <div className="developer-profile-container">
            <h1 className="developer-header">About Lorenzo</h1>
            <img src={Linkedin} alt="Lorenzo's Portrait" className="developer-image" />
            <p className="developer-bio">
                Lorenzo is a Computer Science junior who loves building intuitive, data-driven platforms. 
                He's focused on development and making the site seamless for users. 
                When he's not coding, he's cooking, running his business, or brainstorming new ideas.
            </p>
            <Link to="/about" className="back-button">Back to Developers</Link>
        </div>
    )
}
